import styled from 'styled-components';

export const LoaderContainer = styled.div`
  position: relative;
  width: 100%;
`;
